export const serviceOptions = [
  { name: 'Compartilhamento de Metodologia', id: 1 },
  { name: 'Consulta', id: 2 },
  { name: 'Parecer', id: 3 },
  { name: 'Plano de Adequação', id: 4 },
  { name: 'Processo Judicial', id: 5 },
  { name: 'Processo Administrativo', id: 6 },
  { name: 'Procedimentos Extrajudiciais', id: 7 },
  { name: 'Incidente de Segurança', id: 8 },
  { name: 'Elaboração/Revisão de Documento', id: 9 },
  { name: 'Treinamento/Palestra', id: 10 },
  { name: 'Criação de Solução', id: 11 },
];

export const attendanceDeadlineValues = {
  sla: 'SLA',
  custom: 'CUSTOMIZADO',
};

export const attendanceDeadlineOptions = [
  { name: 'Seguir SLA (5 dias úteis)', id: attendanceDeadlineValues.sla },
  { name: 'Customizado', id: attendanceDeadlineValues.custom },
];

export const internalAreaOptions = [
  {
    name: 'Privacidade e Proteção de Dados',
    id: 'PRIVACIDADE_E_PROTECAO_DE_DADOS',
  },
  {
    name: 'Regulação e Aplicação de Novas Tecnologias',
    id: 'REGULACAO_E_APLICACAO_DE_NOVAS_TECNOLOGIAS',
  },
  {
    name: 'Direito Digital (INATIVO)',
    id: 'DIREITO_DIGITAL_INATIVO',
  },
  {
    name: 'Legal Design',
    id: 'LEGAL_DESIGN',
  },
  {
    name: 'Inteligência Artificial',
    id: 'INTELIGENCIA_ARTIFICIAL',
  },
  {
    name: 'Regulatório Financeiro',
    id: 'REGULATORIO_FINANCEIRO',
  },
];

export const modalityOptions = [
  {
    name: 'Consulta',
    id: 2,
  },
  {
    name: 'Documento',
    id: 9,
  },
  {
    name: 'Contrato',
    id: 12,
  },
];

export const assessmentTypesOptions = [
  {
    name: 'Propriedade Intelectual',
    id: 'PROPRIEDADE_INTELECTUAL',
  },
  {
    name: 'Proteção de Dados',
    id: 'PROTECAO_DE_DADOS',
  },
  {
    name: 'Geral',
    id: 'GERAL',
  },
];
